import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import PencilIcon from '@material-ui/icons/Edit'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import consts from '../../../util/consts'
import Paginate from '../../components/Pagination'
import { fetchLaundryClients } from '../LaundryClientActions'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import Icon from '@mdi/react'
import { mdiAlert, mdiReceiptTextOutline } from '@mdi/js'
import colors from '../../../assets/colors'
import { dateFormatedFullDate, renderRouteRole } from '../../../util/utils'

function List(props) {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.client.filters)
  const role = useSelector(state => state.auth.role)
  const [rowsPerPage, setRowsPerPage] = useState(consts.DEFAULT_PAGINATION)
  const { classes, items, totalSize, page } = props
  const canManageSubscription = renderRouteRole(['administrador'], role)

  const onMovePage = (event, newPage) => {
    dispatch(fetchLaundryClients(newPage + 1, filters, rowsPerPage))
  }

  useEffect(() => {
    onMovePage()
  }, [rowsPerPage])

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value)
  }

  return (
    <>
      <TableContainer className={classes.tableContainer}>
        <Table size="small" className={classes.tableStyle}>
          <TableHead>
            <TableRow>
              <StyledTableCellHeader>ID</StyledTableCellHeader>
              <StyledTableCellHeader style={{ width: '20%' }}>
                Nome
              </StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Ativos / Máximo Usuários
              </StyledTableCellHeader>
              <StyledTableCellHeader>Plano</StyledTableCellHeader>
              <StyledTableCellHeader>Status</StyledTableCellHeader>
              <StyledTableCellHeader>Assinatura</StyledTableCellHeader>
              <StyledTableCellHeader>Último Login</StyledTableCellHeader>
              <StyledTableCellHeader>Último Acesso</StyledTableCellHeader>
              <StyledTableCellHeader align="center">
                Ações
              </StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.map(item => (
              <TableRow key={item.id}>
                <StyledTableCellBody>{item.id}</StyledTableCellBody>
                <StyledTableCellBody>{item.name}</StyledTableCellBody>
                <StyledTableCellBody align="center">
                  {item.active_clients} / {item.max_users}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {item.clientPlan?.name || '-'}
                </StyledTableCellBody>
                <StyledTableCellBody>{item.statusString}</StyledTableCellBody>
                <StyledTableCellBody>
                  {item?.subscription_status_path || '-'}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {dateFormatedFullDate(item?.last_login_at)}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {dateFormatedFullDate(item?.last_seen_at)}
                </StyledTableCellBody>

                <StyledTableCellBody align="center">
                  <IconButton
                    component={Link}
                    to={`/laundry-clients/${item.id}/edit`}
                    title="Editar"
                  >
                    <PencilIcon fontSize="small" />
                  </IconButton>
                  {canManageSubscription && (
                    <IconButton
                      component={Link}
                      to={`/laundry-clients/${item.id}/subscription`}
                      title="Assinatura"
                    >
                      <Icon
                        path={mdiReceiptTextOutline}
                        size={0.85}
                        color={colors.primary}
                      />
                    </IconButton>
                  )}
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <Paginate
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        rows={totalSize}
        page={page - 1}
        handleChangePage={onMovePage}
      /> */}
    </>
  )
}

export default List
